module.exports = __webpack_public_path__ + "img/facebook.ce0c8188.svg";